import React from 'react'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import Meta from '../components/meta'

import OfficeConditions from '../components/OfficeConditions'

class CurrentConditionsPage extends React.Component {
  render() {
    let link = (
      <Link to="/blog/iot-demo-indoor-environmental-sensor-pack-with-mbed-and-aws-iot">
        here
      </Link>
    )
    return (
      <Layout>
        <Meta title="Current Office Conditions" url="current-conditions" />
        <div className="bg-light-gray ">
          <div className="mw9 center">
            <article className="cf ph3 ph5-l pv5">
              <header className="fn fl-l w-40-l pr4-l">
                <time className="f6 ttu tracked gray">Experiment</time>
                <h1 className="mb3 mt0 lh-title">Current Office Conditions</h1>
                <h2 className="f4 fw3 lh-copy">
                  We have an environmental sensor set up in the office to track
                  our working conditions. We wrote about it {link}.
                </h2>
              </header>
              <div className="fn fl-l w-60-l">
                <OfficeConditions />
              </div>
            </article>
          </div>
        </div>
      </Layout>
    )
  }
}

export default CurrentConditionsPage
